module.exports = __webpack_public_path__ + "media/dashboard/assets/images/triangle-1bcffb607117bc8ab09e52d6a043e196.svg";